module.exports = __webpack_public_path__ + "static/blue_dragon_wyrmling-1-eb495a622d2d525a613110db8846ce65.jpg";